var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemUiconsDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42878 12H13.1431M7.42878 14.2857H15.4288M7.42878 16.5714H10.8574M18.8574 17.7143V9.71429L13.1431 4H7.42878C6.82257 4 6.24119 4.24082 5.81254 4.66947C5.38388 5.09812 5.14307 5.67951 5.14307 6.28571V17.7143C5.14307 18.3205 5.38388 18.9019 5.81254 19.3305C6.24119 19.7592 6.82257 20 7.42878 20H16.5716C17.1778 20 17.7592 19.7592 18.1879 19.3305C18.6165 18.9019 18.8574 18.3205 18.8574 17.7143Z",
    stroke: "#1C1612",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1431 4V7.42857C13.1431 8.03478 13.3839 8.61616 13.8125 9.04482C14.2412 9.47347 14.8226 9.71429 15.4288 9.71429H18.8574",
    stroke: "#1C1612",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUiconsDocument);
export default __webpack_public_path__ + "static/media/system-uicons_document.3bd3432b58123e83bc5d607a0a466704.svg";
export { ForwardRef as ReactComponent };